import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Row, Col, Card, CardBody } from "reactstrap"

import { fetchEventandVenue } from "toolkitStore/eventMSlice/eventSlice"
//Import Images
import avatar1 from "../../assets/images/users/avatar-1.jpg"
import user1 from "../../assets/images/users/adminuserlogo.jpg"
import { APIServerIP } from "helpers/Sats_api_helper"

function CardUser({
  TotalMembers,
  memberShipList,
  MemberLifeMembership,
  MemberAnnualFamily,
  MemberStudent,
    memberTypeCounts,
  // inactiveMembers,
}) {
  const [settingsMenu, setSettingsMenu] = useState(false)
  const dispatch = useDispatch()
  const { EventListWithvenue } = useSelector(state => state.EventReducer)
  //Setting Menu
  const Username = JSON.parse(localStorage.getItem("authUser"))
  useEffect(() => {
    dispatch(fetchEventandVenue())
  }, [])
  return (
    <React.Fragment>
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <Row>
                <Col lg="4">
                  <div className="d-flex">
                    <div className="me-3">
                      <img
                        src={user1}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <p className="mb-2">Welcome to SATS Dashboard</p>
                        <h5 className="mb-1">{Username?.user_name}</h5>
                        <p className="mb-0">{Username?.role}</p>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* <Col lg="8" className="align-self-center">
                  <div className="text-lg-center mt-4 mt-lg-0">
                    <Row>
                      <Col xs="3">
                        <div>
                          <p className="text-muted text-truncate mb-2">
                            Total Members
                          </p>
                          <h5 className="mb-0">{TotalMembers}</h5>
                        </div>
                      </Col>
                      <Col xs="3">
                        <div>
                          <p className="text-muted text-truncate mb-2">
                            Lifetime
                          </p>
                          <h5 className="mb-0">{MemberLifeMembership}</h5>
                        </div>
                      </Col>
                      <Col xs="3">
                        <div>
                          <p className="text-muted text-truncate mb-2">Term</p>
                          <h5 className="mb-0">{MemberAnnualFamily}</h5>
                        </div>
                      </Col>
                      <Col xs="3">
                        <div>
                          <p className="text-muted text-truncate mb-2">
                            Student
                          </p>
                          <h5 className="mb-0">{MemberStudent}</h5>
                        </div>
                      </Col>
                      <Col xs="2">
                        <div>
                          <p className="text-muted text-truncate mb-2">
                            Inactive
                          </p>
                          <h5 className="mb-0">{inactiveMembers}</h5>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col> */}
                 <Col lg="8" className="align-self-center">
  <div className="text-lg-center mt-4 mt-lg-0">
    <Row className="g-3 justify-content-center">
      
     
      <Col xs="12" sm="6" md="3">
        <div>
          <p className="text-muted text-truncate mb-2">
            Total Members
          </p>
          <h5 className="mb-0">{TotalMembers}</h5>
        </div>
      </Col>

      
      {memberTypeCounts.map(type => (
        <Col
          key={type._id}
          xs="12"
          sm="6"
          md="3"
        >
          <div>
            <p className="text-muted text-truncate mb-2">
              {type.membership_name}
            </p>
            <h5 className="mb-0">{type.count}</h5>
          </div>
        </Col>
      ))}
    </Row>
  </div>
</Col>


              </Row>
            </CardBody>
          </Card>
          {EventListWithvenue.map((item, ind) => (
            <Card key={ind}>
              <CardBody>
                <Row className="d-flex">
                  <Col lg="4">
                    <div className="d-flex">
                      <div className="me-3">
                        <img
                          src={`${APIServerIP}assets/event_cover/${item.image_name}`}
                          alt=""
                          className="avatar-md rounded img-thumbnail"
                        />
                      </div>
                      <div className="flex-grow-1 align-self-center">
                        <div className="text-muted">
                          <p className="mb-2">SATS Upcoming Event</p>
                          <h5 className="mb-1">{item.name}</h5>
                        </div>
                      </div>
                    </div>
                  </Col>
                 <Col lg="8" className="align-self-center mb-2">
  {item?.venues.map((venue, vIdx) => (
    <Col
      lg="12"
      key={vIdx}
      className={`align-self-center mb-2 ${
        item.type === "FREE" ? "text-center" : ""
      }`}
    >
      <div className="text-lg-center mt-4 mt-lg-0">
        <Row className={item.type === "FREE" ? "justify-content-center" : ""}>
           <Col xs={item.type === "FREE" ? 12 : 5}>
            <div className="mb-3"> 
              <p className="text-muted mb-1">Venue</p>
              <h5 className="mb-0">{venue.venue}</h5>
            </div>
          </Col>

           {item.type === "PAID" && (
            <>
              <Col xs="3">
                <div>
                  <p className="text-muted text-truncate mb-2">Total Tickets</p>
                  <h5 className="mb-0">{venue.max_tickets}</h5>
                </div>
              </Col>
              <Col xs="2">
                <div>
                  <p className="text-muted text-truncate mb-2">Remaining</p>
                  <h5 className="mb-0">
                    {Number(venue.max_tickets) - Number(venue.ticket_sold)}
                  </h5>
                </div>
              </Col>
              <Col xs="2">
                <div>
                  <p className="text-muted text-truncate mb-2">Sold</p>
                  <h5 className="mb-0">{venue.ticket_sold}</h5>
                </div>
              </Col>
            </>
          )}

         
            {item.type === "FREE" &&
 item.freeFoodType === "PAID_FOOD" &&
 venue.booking_stats && (
   <Row className="text-center mt-3">
     {venue.booking_stats.veg_adult_count + 
      venue.booking_stats.veg_child_count +
      venue.booking_stats.nonveg_adult_count + 
      venue.booking_stats.nonveg_child_count > 0 ? (
        <>
         <Col xs="4">
           <p className="text-muted fw-bold fs-5 mb-1">Veg</p>
           <div>Adult: <strong>{venue.booking_stats.veg_adult_count}</strong></div>
           <div>Child: <strong>{venue.booking_stats.veg_child_count}</strong></div>
         </Col>
         <Col xs="4">
           <p className="text-muted fw-bold fs-5 mb-1">Non-Veg</p>
           <div>Adult: <strong>{venue.booking_stats.nonveg_adult_count}</strong></div>
           <div>Child: <strong>{venue.booking_stats.nonveg_child_count}</strong></div>
         </Col>
         <Col xs="4">
           <p className="text-muted fw-bold fs-5 mb-1">Total</p>
           <div>Veg: <strong>{venue.booking_stats.total_veg}</strong></div>
           <div>Non-Veg: <strong>{venue.booking_stats.total_nonveg}</strong></div>
         </Col>
       </>
     ) : (
        <>
         <Col xs="6">
           <p className="text-muted fw-bold fs-5 mb-1">Veg</p>
           <div><strong>{venue.booking_stats.total_veg}</strong></div>
         </Col>
         <Col xs="6">
           <p className="text-muted fw-bold fs-5 mb-1">Non-Veg</p>
           <div><strong>{venue.booking_stats.total_nonveg}</strong></div>
         </Col>
       </>
     )}
   </Row>
)}

        </Row>
      </div>
    </Col>
  ))}
 

                    


                    {/* <Col lg="12" className="align-self-end ">
                      <div className="text-lg-center mt-4 mt-lg-0">
                        <Row>
                          <Col xs="3">
                            <div>
                              <p className="text-muted text-truncate mb-2">
                                Venue
                              </p>
                              <h5 className="mb-0">{TotalMembers}</h5>
                            </div>
                          </Col>
                          <Col xs="3">
                            <div>
                              <p className="text-muted text-truncate mb-2">
                                Total Tickets
                              </p>
                              <h5 className="mb-0">{MemberLifeMembership}</h5>
                            </div>
                          </Col>
                          <Col xs="3">
                            <div>
                              <p className="text-muted text-truncate mb-2">
                                Remaining Tickets
                              </p>
                              <h5 className="mb-0">{MemberAnnualFamily}</h5>
                            </div>
                          </Col>
                          <Col xs="3">
                            <div>
                              <p className="text-muted text-truncate mb-2">
                                Sold Tickets
                              </p>
                              <h5 className="mb-0">{MemberStudent}</h5>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col> */}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ))}
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default CardUser
